import { ExportItemSkeleton } from '@/features/DataHub/pages/PastExports/components/ExportItemSkeleton';

export const ExportItemsSkeleton = () => {
  return (
    <>
      <ExportItemSkeleton />
      <ExportItemSkeleton />
      <ExportItemSkeleton />
    </>
  );
};
